<script lang="ts">
	const {
		x,
		y,
		r,
		blur,
		width,
		height,
		id,
		fill = '#685D50',
		offset = { x: 0, y: 0 },
		...rest
	}: {
		x: number;
		y: number;
		r: number;
		id?: string;
		fill?: string;
		blur?: number;
		width?: number;
		height?: number;
		offset?: { x: number; y: number };
	} = $props();

	const uid = $derived(`${x}-${y}-${r}-${id ?? ''}`);
	const blurId = $derived(`blur-${uid}`);
	const cutId = $derived(`cut-${uid}`);
</script>

<defs>
	{#if blur !== undefined}
		<filter id={blurId} x="-50%" y="-50%" width="200%" height="200%">
			<feGaussianBlur in="SourceGraphic" stdDeviation={blur} />
		</filter>
	{/if}
	<!-- <rect x="0" y="0" width="200%" height="200%" fill="red" /> -->
	{#if width && height}
		<clipPath id={cutId}>
			<rect x={x - width * 0.5} y={y - height * 0.5} {width} {height} />
		</clipPath>
	{/if}
</defs>

<circle
	cx={x + offset.x}
	cy={y + offset.y}
	{r}
	{fill}
	filter="url(#{blurId})"
	clip-path="url(#{cutId})"
	{...rest}
></circle>

<style lang="scss">
	feGaussianBlur {
		will-change: stdDeviation;
	}
	circle {
		will-change: transform, filter, clip-path;
	}
</style>
